/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type HpRespCollectionsModule_homepage$ref = any;
type HpRespEditorialModule_homepage$ref = any;
type HpRespFeaturedModule_homepage$ref = any;
type HpRespHeroModule_homepage$ref = any;
type HpRespInformationalContent_viewer$ref = any;
type HpRespPersonalizationModule_personalization$ref = any;
type HpRespPromoModulePrimary_homepage$ref = any;
type HpRespPromoModuleSecondary_homepage$ref = any;
type HpRespRecentlyViewedItems_user$ref = any;
type HpRespShopByModule_homepage$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type HpRespLayout_viewer$ref: FragmentReference;
export type HpRespLayout_viewer = {|
  +homepage: ?{|
    +personalization?: ?{|
      +$fragmentRefs: HpRespPersonalizationModule_personalization$ref
    |},
    +$fragmentRefs: HpRespHeroModule_homepage$ref & HpRespPromoModulePrimary_homepage$ref & HpRespCollectionsModule_homepage$ref & HpRespFeaturedModule_homepage$ref & HpRespPromoModuleSecondary_homepage$ref & HpRespEditorialModule_homepage$ref & HpRespShopByModule_homepage$ref,
  |},
  +user?: ?{|
    +$fragmentRefs: HpRespRecentlyViewedItems_user$ref
  |},
  +$fragmentRefs: HpRespInformationalContent_viewer$ref,
  +$refType: HpRespLayout_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId",
  "type": "String!"
};
return {
  "kind": "Fragment",
  "name": "HpRespLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "homepageId",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "numPersonalizationItems",
      "type": "Int!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "homepage",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "rootId",
          "variableName": "homepageId",
          "type": "String"
        }
      ],
      "concreteType": "Homepage",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "HpRespHeroModule_homepage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "HpRespPromoModulePrimary_homepage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "HpRespCollectionsModule_homepage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "HpRespFeaturedModule_homepage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "HpRespPromoModuleSecondary_homepage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "HpRespEditorialModule_homepage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "HpRespShopByModule_homepage",
          "args": null
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "hasUserId",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "personalization",
              "storageKey": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 4,
                  "type": "Int"
                },
                {
                  "kind": "Variable",
                  "name": "numItems",
                  "variableName": "numPersonalizationItems",
                  "type": "Int!"
                },
                (v0/*: any*/)
              ],
              "concreteType": "PersonalizationModuleConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "HpRespPersonalizationModule_personalization",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "HpRespInformationalContent_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            (v0/*: any*/)
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "HpRespRecentlyViewedItems_user",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '5e8e4d6a0801c467cedb9ed5d6b77dcd';
module.exports = node;
